import React, { useEffect, useState } from 'react';
import { api } from '../../App';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Mail } from 'lucide-react';

const OwnerRow = ({ biz, onSaved }) => {
  const [email, setEmail] = useState(biz.owner_email || '');
  const [saving, setSaving] = useState(false);
  const isSraivest = biz.owner_type === 'sraivest';
  const changed = (email || '') !== (biz.owner_email || '');

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/sb-live/admin/owners/${biz.business_id}`, { owner_email: email.trim() || null });
      toast.success(`Owner email saved for ${biz.name}`);
      onSaved();
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Please enter a valid email address');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 py-2 border-b border-white/5" data-testid={`owner-row-${biz.business_id}`}>
      <div className="sm:w-56 min-w-0">
        <p className="text-white text-sm truncate">{biz.name}</p>
        <p className="text-xs text-gray-500">{isSraivest ? 'Owned by Sraivest' : biz.owner_name || 'Owner'}</p>
      </div>
      {isSraivest ? (
        <p className="text-xs text-gray-500 flex-1">Pays Sraivest directly, no owner email needed</p>
      ) : (
        <>
          <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="owner@email.com" type="email"
            className="flex-1 bg-white/5 border-white/10 text-white h-9" data-testid={`owner-email-input-${biz.business_id}`} />
          {!biz.owner_email && <span className="text-xs text-[#F7931A]" data-testid={`owner-missing-${biz.business_id}`}>Missing</span>}
          <Button size="sm" disabled={!changed || saving} onClick={save} className="btn-primary disabled:opacity-40" data-testid={`owner-save-btn-${biz.business_id}`}>
            {saving ? 'Saving…' : 'Save'}
          </Button>
        </>
      )}
    </div>
  );
};

export const BusinessOwnersCard = () => {
  const [owners, setOwners] = useState([]);
  const load = () => api.get('/sb-live/admin/owners').then((r) => setOwners(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <Card className="bg-[#0F0F0F] border-white/10" data-testid="admin-business-owners-card">
      <CardHeader>
        <CardTitle className="text-white flex items-center gap-2"><Mail className="w-5 h-5 text-[#00E676]" /> Business Owner Emails</CardTitle>
        <p className="text-xs text-gray-500">Payouts go to the Sraivest account with this email once its owner links a bank through Stripe.</p>
      </CardHeader>
      <CardContent>
        {owners.map((b) => <OwnerRow key={`${b.business_id}-${b.owner_email}`} biz={b} onSaved={load} />)}
      </CardContent>
    </Card>
  );
};
